angular.module('aprima-config', ['lodash']);